import {version} from "../../config";

export default theme => ({
	"@global": { //need add into global rules
		"@keyframes pulsate": {
			"0%, 100%": {
				top: "45%"
			},
			"50%": {
				top: "50%"
			}
		}
	},
	"@-ms-viewport": {
		width: "device-width"
	},
	wrapper: {
		overflow: "hidden"
	},
	header: {
		width: "100vw"
	},
	main: {
		width: "75vw",
		height: "100%"
	},
	sidebar: {
		width: "25vw",
		height: "100%"
	},
	districtMode: {
		width: "80vw",
		height: "100vh",
		overflow: "hidden",
		position: "relative",
		background: "#333",
		"& img": {
			width: "100%",
			height: "100vh",
			objectFit: "none"
		}
	},
	drawerPaper: {
		width: "20vw",
		height: "100%",
		padding: theme.spacing.unit * 1.5
	},
	toolbar: theme.mixins.toolbar,
	paper: {
		marginBottom: 8,
		padding: "12px 8px",
		backgroundColor: theme.palette.primary.main,
		color: "white",

		cursor: "pointer",
		"&.active-poi": {
			backgroundColor: theme.palette.secondary.main
		},
		"&:hover": {
			backgroundColor: theme.palette.secondary.main
		}
	},
	poiList: {
		textDecoration: "none",
		fontSize: "12px"
	},
	poiInImg: {
		background: "#000",
		fontSize: "14px",
		padding: "9px",
		marginLeft: "-13px",
		marginTop: "-16px",
		borderRadius: "28px",
		cursor: "pointer",
		width: "33px",
		height: "33px",
		"& svg": {
			width: "16px",
			height: "16px",
			fill: "#fff"
		},
		"&:hover": {
			background: "#fff",
			"& svg": {
				fill: "#000"
			}
		},
		"&.active-poi": {
			backgroundColor: "#fff",
			"& svg": {
				fill: "#000"
			}
		}
	},
	resultHeaderAppBar: {
		marginBottom: theme.spacing.unit * 3,
		boxShadow: "none"
	},
	resultHeaderToolbar: {
		padding: 0,
		alignItems: "center"
	},
	resultHeaderTitle: {
		fontWeight: "600",
		marginRight: theme.spacing.unit / 2
	},
	resultHeaderCount: {
		color: theme.palette.primary.main,
		fontWeight: "600",
		marginRight: theme.spacing.unit / 2,
		fontSize: "1.3rem"
	},
	resultHeaderActions: {
		width: "100%",
		textAlign: "right"
	},
	resultHeaderButton: {
		backgroundColor: theme.palette.background.default,
		marginRight: theme.spacing.unit / 4,
		"&:last-child": {
			marginRight: 0
		},
		padding: `${theme.spacing.unit / 4}px ${theme.spacing.unit - 2}px`,
		fontSize: "0.8rem",
		height: "auto",
		"@media (max-width:1440px)": {
			fontSize: "0.65rem"
		},
		"@media (max-width:960px)": {
			fontSize: "0.8rem"
		}
	},
	resultHeaderIcon: {
		fill: theme.palette.primary.main,
		width: 14,
		height: 14,
		marginRight: theme.spacing.unit / 4,
		"@media (max-width:1440px)": {
			width: 10,
			height: 10
		},
		"@media (max-width:960px)": {
			width: 16,
			height: 16
		}
	},
	wrapperPoiMedia: {
		paddingBottom: theme.spacing.unit * 10
	},
	primaryColor: {
		color: theme.palette.primary.main,
		fill: theme.palette.primary.main
	},
	btnBack: {
		backgroundColor: theme.palette.common.white,
		position: "absolute",
		top: 70,
		left: 20,
		zIndex: 1,
		fontSize: "0.9rem",
		padding: `${theme.spacing.unit / 4}px ${theme.spacing.unit + 4}px`,
		minHeight: "auto",
		height: "auto"
	},
	googleMapIcon: {
		marginRight: theme.spacing.unit / 2,
		width: "2rem",
		height: "2rem"
	},
	drawerPaperSideBar: {
		width: "20vw",
		height: "100%",
		padding: theme.spacing.unit * 1.5
	},
	scrollIcon: {
		display: "none",
		position: "absolute",
		background: "rgba(0,0,0,0.8)",
		width: "100%",
		height: "100%",
		zIndex: "9999999",
		left: 0,
		bottom: 0,
		"& span": {
			top: "20%",
			position: "relative",
			color: "#fff",
			fontSize: "14px",
			display: "flex",
			padding: "0px 16px",
			width: "300px",
			margin: "0 auto",
			textAlign: "center",
		},
		"& svg": {
			width: "80px",
			height: "auto",
			margin: 0,
			position: "absolute",
			animation: "$pulsate 1.5s linear infinite",
			top: "50%",
			left: "50%",
			transform: "translate(-50%, -50%)",
			"& path": {
				fill: "#F6F5F5"
			}
		}
	},
	[theme.breakpoints.down("sm")]: {
		wrapper: {
			display: "flex",
			flexDirection: "column-reverse"
		},
		header: {
			width: "100vw"
		},
		main: {
			width: "100vw",
			height: "auto"
		},
		sidebar: {
			width: "100vw",
			height: "auto"
		},

		resultHeaderTitle: {
			marginBottom: theme.spacing.unit / 2
		},
		districtMode: {
			width: "auto",
			height: "auto",
			overflow: "auto",
			// scrollBehavior: "auto",
			"& img": {
				width: "auto",
				height: "auto"
			}
		},
		drawerPaperSideBar: {
			width: "100vw"
		},
		btnBack: {
			position: "fixed"
		},
		scrollShow: {
			display: "block"
		},
		scrollHide: {
			display: "none"
		}
	}
});
export const details = theme => ({
	header: {
		width: "100vw"
	},
	root: {
		width: "20vw",
		height: "100vh",
		boxShadow: "none",
		minWidth: 300,
		padding: 0,
		color: theme.palette.common.white,
		border: 0,
		zIndex: 1,
		position: "relative"
	},
	wrapper: {
		backgroundColor: theme.palette.common.black,
		height: "100%",
		overflowY: "auto",
		display: "flex",
		flexDirection: "column",
		paddingBottom: "4rem",
		paddingRight: "9px",
		paddingLeft: "9px"
	},
	title: {
		display: "flex",
		flexDirection: "column",
		color: "#fff",
		padding: `${theme.spacing.unit * 5}px ${theme.spacing.unit * 2}px ${theme
			.spacing.unit * 5}px`,
		fontSize: "23px",
		lineHeight: "1.3em",
		fontWeight: 600,
		flexShrink: 0,
		flexGrow: 0,
		"& $subTitle": {
			fontSize: "0.8em"
		}
	},
	subTitle: {
		fontSize: "17px",
		color: "#fff",
		fontWeight: 600,
		marginTop: theme.spacing.unit / 2,
		"&.spacer": {
			marginTop: "1vh",
			flexShrink: 0,
			flexGrow: 0
		}
	},

	poiGallery: {
		background: "#333"
	},
	mainWrapper: {
		width: "100vw"
	},
	sidebar: {
		width: "100vw",
		height: "auto"
	},

	value: {
		fontSize: "1.1em",
		fontWeight: 600,
		marginTop: theme.spacing.unit / 2,
		display: "block",
		textAlign: "center",
		"& > span": {
			display: "inline-flex",
			textAlign: "center"
		}
	},
	grid: {
		textAlign: "center",
		color: theme.palette.common.white,
		marginBottom: "2vh"
	},
	icon: {
		width: 35,
		height: 35,
		margin: `0 0 ${theme.spacing.unit}px 0`,
		fill: !version.office
			? theme.palette.primary.main
			: theme.palette.secondary.main,
		fontWeight: 900,
		"@media (min-width:960px) and (max-width:1440px)": {
			width: 24,
			height: 24
		}
	},

	actions: {
		textAlign: "center",
		justifyContent: "center",
		display: "flex",
		marginTop: "1.5vh",
		"&:last-child": {
			marginTop: "3.5vh"
		}
	},
	btn: {
		padding: "0.7em 1.5em",
		fontSize: "15px",
		marginRight: theme.spacing.unit,
		height: "auto",
		minHeight: "auto",
		"&:last-child": {
			marginRight: 0
		},
		backgroundColor: "#fff"
	},
	btnBig: {
		padding: "0.8em 1.7em",
		fontSize: "1.5em",
		height: "auto",
		minHeight: "auto",
		borderRadius: theme.spacing.unit * 8,
		color: theme.palette.primary.contrastText,
		backgroundColor: theme.palette.primary.main
	},
	[theme.breakpoints.down("md")]: {
		"@global": {
			body: {
				fontSize: "0.6rem",
				overflowY: "auto!important",
			}
		},

		drawerPaper: {
			width: "20vw"
		},
		drawerWrapper: {
			padding: `0 ${theme.spacing.unit * 4}px`
		},
		btn: {
			fontSize: "15px"
		},
		btnBig: {
			fontSize: "1.2em"
		}
	},
	[theme.breakpoints.down("sm")]: {
		"@global": {
			body: {
				fontSize: "1rem",
				background: "#333"
			},
			".afficher": {
				position: "relative",
				bottom: "0"
			}
		},
		wrapper: {
			width: "100vw",
			marginTop: "50px"
		},
		drawerPaper: {
			width: "100vw"
		},
		drawerWrapper: {
			padding: `0 ${theme.spacing.unit * 4}px`
		},
		appBar: {
			width: "100vw"
		},
		".benefitWrapper": {
			display: "flex !important",
			flexDirection: "column",
			alignItems: "center"
		}
	}
});

export const slideshow = theme => ({
	"@global": {
		".image-gallery": {
			background: "#333"
		},
		".image-gallery-slides": {
			"& :focus": {
				outline: "none"
			}
		},
		".image-gallery-slide .image-gallery-image": {
			// height: "100vh",
			// objectFit: "cover"
		},
		".image-gallery-content .image-gallery-slide .image-gallery-image": {
			maxHeight: "94vh",
			height: "94vh"
		},
		".office-poi-description": {
			padding: "20px",
			fontWeight: "100!important"
		},
		".afficher": {
			position: "absolute",
			bottom: "97px",
			width: "100%"
		},
		".image-gallery-icon:focus": {
			outline: `2px solid ${theme.palette.primary.main}`
		},
		".rc-tabs-tab": {
			height: "4rem !important",
			fontSize: "1.6rem !important",
			alignItems: "center",
			margin: "0 !important",
			float: "none !important",
			display: "block",
			width: "100%",
			textAlign: "center",
			lineHeight: "4rem",
			padding: 0,
			textTransform: "uppercase",
			fontFamily: "Questrial,Arial,sans,sans-serif"
		},
		".rc-tabs-bottom .rc-tabs-content": {
			height: "calc(100vh - 50px - 4rem)"
		},
		".rc-tabs-tab-active, .rc-tabs-tab-active:hover": {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText
		},
		".rc-tabs-tab:hover:not(.rc-tabs-tab-active)": {
			backgroundColor: theme.palette.primary.dark,
			color: theme.palette.primary.contrastText
		},
		".rc-tabs-content .rc-tabs-tabpane": {
			overflow: "hidden"
		}
	},
	main: {
		width: "75vw",
		height: "100%"
	},
	header: {
		width: "100vw"
	},

	poiGallery: {
		background: "#333"
	},
	mainWrapper: {
		width: "80vw"
		// height: "100vh"
		// display: "flex",
		// justifyContent: "center"
	},
	appBar: {
		"& > div": {
			display: "flex"
		},
		// ...theme.mixins.toolbar,
		border: "0 !important"
		// top: "auto",
		// bottom: 0,
		// left: 0,
		// width: "80vw"
	},
	tabs: {
		border: 0
	},
	tab: {
		overflow: "hidden !important"
		// height: "4rem",
		// fontSize: "1.6rem"
	},
	selected: {},
	tabWrapper: {
		// width: "100%",
		// height: "100%",
		// position: "relative",
		// top: 0,
		// left: 0
	},
	iframe: {
		width: "80vw",
		height: "calc(100vh - 50px - 4rem)",
		overflow: "hidden"
	},
	canvas: {
		// height: "calc(100% - 50px)"
	},
	canvasFullHeight: {
		height: "calc(100vh - 50px)",
		[theme.breakpoints.down("sm")]: {
			height: "auto",
			width: "100vw"
		}
	},

	[theme.breakpoints.down("sm")]: {
		"@global": {
			".rc-tabs-tab": {
				fontSize: "1rem !important"
			}
		},
		mainWrapper: {
			width: "100vw"
		},
		appBar: {
			width: "100vw"
		},
		iframe: {
			width: "100vw"
		}

	}
});
